<template>
    <section class="innerpages animate__animated animate__slideInRight">
       <div class="container ">
          <div class="row">
             <div class="col-md-12 listPage">
                <nav aria-label="breadcrumb">
                   <ol class="breadcrumb">
                      <li class="breadcrumb-item"><a>{{mainLabel}} Report</a></li>
                      <li class="breadcrumb-item" v-if="mainLabel === 'Lead Ageing'"><a>Ageing Leads</a></li>
                      <li class="breadcrumb-item" v-if="mainLabel === 'Marketing Campaign'"><a>Leads</a></li>
                      <template v-else>
                      <li class="breadcrumb-item"><a>{{secondLabel}}</a></li>
                      <li class="breadcrumb-item" v-if="lastLabel"><a>{{lastLabel}}</a></li>
                      </template>
                   </ol>
                </nav>
                
                <div class="d-flex align-items-center" style="gap: 4px;">
                  <!-- Search Input Field -->
                  <div class="position-relative flex-grow-1">
                    <!-- Search Icon -->
                    <svg class="search-icon" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background:new 0 0 451 451;" xml:space="preserve">
                      <g>
                        <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                          s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                          C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                          s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z"/>
                      </g>
                    </svg>
                    <input type="text" placeholder="Search by name" class="search form-control pr-4 my-0"  v-model.trim="searchQuery"/>
                    <button v-if="searchQuery" @click="resetFilter" type="button" class="btn-clear">
                      <svg data-v-37888afc="" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none"><path data-v-37888afc="" d="M4.40928 13.3344L3.66553 12.5906L7.75615 8.50002L3.66553 4.4094L4.40928 3.66565L8.4999 7.75627L12.5905 3.66565L13.3343 4.4094L9.24365 8.50002L13.3343 12.5906L12.5905 13.3344L8.4999 9.24377L4.40928 13.3344Z" fill="#373F44"></path></svg>
                    </button>
                  </div>
                  <!-- Apply Button -->
                  <div class="px-0">
                    <button class="btn btn-outline btnFilter" @click="loadTabData">Apply</button>
                  </div>
                </div>
  
                   <div class="card source-details" v-for="(item, key) in masterData" :key="`lead${key}`">
                     <router-link :to="{name: 'Lead', params: {uuid: item.uuid}}" class="lead-detail-link">
                       <div class="card-body">
                          <div class="row">
                             <div class="col-8">
                                <span class="info-title">{{item.client_name}}</span>
                                <span class="project-title">{{item.enquiry}}</span>
                             </div>
                             <div class="col-4 text-right pl-0">
                                <span class="label-Lead">{{item.source}}</span>
                                <span class="label-status">{{item.sub_source}}</span>
                                <span class="label-status">{{item.status}}</span>
                                <span class="label-status">{{item.sub_status}}</span>
                             </div>
                             <div class="col-12">
                                <span class="label-assign">Assigned to: <span class="d-text">{{item.assigned_to}}</span></span>
                                <span class="more d-block" style="font-size:14px">{{item.comment}}</span>
                                <span v-if="item.ncd" class="label-assign ncd">NCD: <span class="d-text">{{item.ncd}}</span></span>
                             </div>
                          </div>
                       </div>
                     </router-link>
                   </div>
                   <span style="font-size:12px;">Count: {{masterData.length}}</span>
             </div>
          </div>
       </div>
    </section>
  </template>
  <script>
  export default {
   data(){
     return {
       masterData: [],
       secondLabelProp: "",
       mainLabel: "",
       searchQuery: ''
     }
   },
   created(){
     this.loadTabData();
   },
   computed: {
    lastLabel(){
        return this.$route.params.itemType === 'callactivity' ?  (this.masterData[0] || {}).sales_manager : this.$route.params.itemType === 'marketing_activation' ? '' : (this.masterData[0] || {}).status
      },
     secondLabel(){
       if(this.masterDataEl.hasOwnProperty(this.secondLabelProp)){
         return this.masterDataEl[this.secondLabelProp]
       }
     },
     masterDataEl(){
       return (this.masterData[0] || {})
     }
   },
   updated(){
     this.executeMoreLink();
   },
   watch: {
    $route(to, from) {
      this.loadTabData();
    },
  },
   methods: {
     executeMoreLink(){
       var showChar = 41;  // How many characters are shown by default
       var ellipsestext = "...";
       var moretext = "More";
       var lesstext = "Less";
       $('.more').each(function() {
           var content = $(this).html();
           if(content.length > showChar) {
             var c = content.substr(0, showChar);
             var h = content.substr(showChar, content.length - showChar);
               var html = c + '<span class="moreellipses">' + ellipsestext+ '&nbsp;</span><span class="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="" class="morelink text-link w-500">' + moretext + '</a></span>';
               $(this).html(html);
           }
       });
       $(".morelink").click(function(){
         if($(this).hasClass("less")) {
             $(this).removeClass("less");
             $(this).html(moretext);
         } else {
             $(this).addClass("less");
             $(this).html(lesstext);
         }
         $(this).parent().prev().toggle();
         $(this).prev().toggle();
         return false;
       });
     },
     resetFilter() {
       this.searchQuery = ''
       this.loadTabData()
     },
     loadTabData(){
      let { itemType, itemId, projectid, userid } = this.$route.params;
        let {
          lead_type,
          start_date,
          end_date,
          full_name,
          status_id,
          manager_ids,
          user_ids,
          project_ids,
          lead_statuses,
          third_party_ids,
          runo_call_user,
          lead_sub_statuses, 
          executive_type,
          enquiry,
          todays_call,
          source_ids,
          take_rate_from,
          take_rate_upto,
          average_ticket_size_from,
          average_ticket_size_upto,
          average_revenue_from,
          average_revenue_upto,
          user_active,
          enquiry_source_id,
          is_star_project,
          is_qualified,
          ageing_time_range,
          ageing_status_type,
          sub_project_ids,
          ads_keyword,
          physical_pincode,
          utm_source,
          utm_campaign,
          ads_group_id,
          ads_name,
          campaign_id,
          device,
          campaign_name,
          keyword_type,
          ad_strategy,
          lead_is_qualified,
          visited,
          re_engaged,
          physical_location_name

        } = this.$route.query;

        let apiEndpoint = "";
        
        if (itemType === "callactivity") {
          this.mainLabel = "Call Activity";
          this.secondLabelProp = "assigned_to";
          apiEndpoint = `/users/${itemId}/leads`;
          this.$store.dispatch("setActiveTitle", "Call Activity Report");
        }else if (itemType === "backlog") {
          this.mainLabel = "Backlog";
          this.secondLabelProp = "assigned_to";
          apiEndpoint = `user/${itemId}/status/${status_id}/back_log_leads`;
          this.$store.dispatch("setActiveTitle", "Backlog Report");
        }else if (itemType === "roi") {
          this.mainLabel = "ROI User Wise";
          this.secondLabelProp = "assigned_to";
          apiEndpoint = `users/${itemId}/roi_user_wise_leads`;
          this.$store.dispatch("setActiveTitle", "ROI User Wise Report");
        }else if (itemType === "project_roi") {
          this.mainLabel = "ROI Project Wise";
          this.secondLabelProp = "assigned_to";
          apiEndpoint = `projects/${itemId}/roi_project_wise_leads`;
          this.$store.dispatch("setActiveTitle", "ROI Project Wise Report");
        } else if (itemType === "source_roi") {
          this.mainLabel = "ROI Source Wise";
          this.secondLabelProp = "source";
          apiEndpoint = `sources/${itemId}/roi_source_wise_leads`;
          this.$store.dispatch("setActiveTitle", "ROI Source Wise Report");
        } else if (itemType === "marketing_activation") {
          this.mainLabel = "Marketing Activation";
          this.secondLabelProp = "source";
          apiEndpoint = `projects/${itemId}/marketing_activation_leads`;
          this.$store.dispatch("setActiveTitle", "Marketing Activation Report");
        } else if (itemType === "lead_ageing_details") {
          this.mainLabel = "Lead Ageing";
          this.secondLabelProp = "source";
          apiEndpoint = `lead_ageing_details/${userid}/projects/${projectid}`;
          this.$store.dispatch("setActiveTitle", "Lead Ageing Report");
        }else if (itemType === "marketing-campaign-report-leads") {
          this.mainLabel = "Marketing Campaign";
          this.secondLabelProp = "source";
          apiEndpoint = `marketing_campaign_report_leads/${itemId}/source/${enquiry_source_id}`;
          this.$store.dispatch("setActiveTitle", "Marketing Campaign Report");
        }else {
          this.$router.replace("/");
          return;
        }
        let params = {
          start_date: start_date,
          end_date: end_date,
          project_ids: project_ids || this.$store.getters.selectedProjectIds.join(","),
          manager_ids: manager_ids || this.$store.getters.multiManger.join(","),
          user_ids: user_ids || this.$store.getters.exeusers.join(","),
          lead_statuses: lead_statuses || this.$store.getters.status.join(","),
          lead_sub_statuses: lead_sub_statuses || this.$store.getters.substatus.join(","),
          executive_type: executive_type || this.$store.getters.executive,
          enquiry: enquiry || this.$store.getters.enquiry,
          todays_call: todays_call || this.$store.getters.todays_call,
          source_ids: source_ids || this.$store.getters.selectedSources.join(','),
          third_party_ids: third_party_ids || this.$store.getters.third_parties.join(","),
          runo_call_user: runo_call_user || this.$store.getters.runo_user || "",
          lead_type: lead_type || '',
          status_id: status_id || '',
          take_rate_from: take_rate_from || this.$store.getters.take_rate_from || "",
          take_rate_upto: take_rate_upto || this.$store.getters.take_rate_upto || "",
          average_ticket_size_from: average_ticket_size_from || this.$store.getters.average_ticket_size_from || "",
          average_ticket_size_upto: average_ticket_size_upto || this.$store.getters.average_ticket_size_upto || "",
          average_revenue_from: average_revenue_from || this.$store.getters.revenue_from || "",
          average_revenue_upto: average_revenue_upto || this.$store.getters.revenue_upto || "",
          user_active: user_active || this.$store.getters.user_active || "",
          is_qualified: is_qualified || '',
          enquiry_source_id: enquiry_source_id || '',
          is_star_project: is_star_project || '',
          ageing_status_type: ageing_status_type || '',
          ageing_time_range: ageing_time_range || '',
          sub_project_ids:sub_project_ids || '',
          ads_keyword: ads_keyword || '',
          physical_pincode: physical_pincode || '',
          utm_source: utm_source || '',
          utm_campaign: utm_campaign || '',
          ads_group_id: ads_group_id || '',
          ads_name: ads_name || '',
          campaign_id: campaign_id || '',
          device: device || '',
          campaign_name: campaign_name || '',
          keyword_type: keyword_type || '',
          ad_strategy: ad_strategy || '',
          enquiry_source_id: enquiry_source_id || '',
          lead_is_qualified: lead_is_qualified || '',
          re_engaged: re_engaged || '',
          visited: visited || '',
          physical_location_name: physical_location_name || '',
        };
        if (this.searchQuery) {
          params.full_name = this.searchQuery;
          params.is_advanced_search = true;
        }
        Object.keys(params).forEach((key) => {
          if (!params[key]) delete params[key];
        });

        if (JSON.stringify(this.$route.query) !== JSON.stringify(params)) {
          this.$router.replace({ path: this.$route.path, query: params }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
        const searchDataUrl = new URLSearchParams(params).toString();
       this.$axios.get(`${apiEndpoint}?${searchDataUrl}`)
         .then(res => this.masterData = res.data)
         .catch(err => swal("Error", err.response.data.message, "error"));
       }
   }
  }
  </script>
  <style scoped>
  .ncd{
   float: none;
   margin-top: 5px;
   margin-bottom: 0;
   display: block;
  }
  .lead-detail-link{
   text-decoration: none;
  }
  
  .btn-clear, .search-icon{
   position: absolute;
   top: 50%;
   right: 4px;
   transform: translateY(-50%);
   background-color: transparent;
   border: none;
   outline: none;
  }
  
  .search-icon{
   right: unset;
   left: 12px;
   width: 15px;
   height: 15px;
   opacity: 0.5;
  }
  
  .btnFilter{
   font-size: 12px;
   padding:12px;
   background-color: #F8E2D0;
   color: rgba(0, 0, 0, 0.5);
   font-weight: 500;
   background: #F2F2F2;
   box-shadow: 2px 3px 16px #F2F2F2;
   border: .25px solid #F2F2F2;
  }
  </style>